module.exports = __webpack_public_path__ + "static/img/fwsB.1b4a0c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/supplyHome/fwsB.png
// module id = 7DEs
// module chunks = 2